import { useSDK } from './useSDK';

export function useNativeModule<T = unknown>(name: string): T {
  const sdk = useSDK();
  const mod = sdk.modules[name];
  if (!mod) {
    throw new Error(`Native module "${name}" is not provided by the super-app`);
  }
  return mod as T;
}
